import cn from "classnames"

import {
  BorderBeam,
  Flex,
  Text,
  TextArea as TextAreaAtom,
  type TextAreaProps
} from "@/atoms"
import { InfoCircleOutlined } from "@/icons"

import styles from "./GuidanceFormSection.module.scss"

import type { TFunction } from "@/hooks/useTranslation"

export const TextArea = (
  props: TextAreaProps & {
    isPending: boolean
    refTextArea: React.RefObject<React.ElementRef<typeof TextAreaAtom>>
    t: TFunction
  }
) => {
  const { isPending, refTextArea, t, ...rest } = props

  return (
    <BorderBeam
      duration={2}
      lineWidth={2}
      size={190}
      color={[
        { color: "rgba(54, 207, 201, 1)", percent: 0 },
        { color: "rgba(54, 207, 201, 1)", percent: 60 },
        { color: "#b791c0", percent: 100 }
      ]}
    >
      <TextAreaAtom
        ref={refTextArea}
        showCount={{
          formatter: ({ count, maxLength }) => {
            return (
              <Flex align="center" justify="between" gap={16}>
                <Flex
                  flex={1}
                  gap={4}
                  align="center"
                  className={styles.description}
                >
                  <InfoCircleOutlined />
                  <Text ellipsis type="secondary" className="sm-text-ks">
                    {t("hint")}
                  </Text>
                </Flex>
                <span>{`${count}/${maxLength}`}</span>
              </Flex>
            )
          }
        }}
        autoSize={{ minRows: 4, maxRows: 6 }}
        maxLength={500}
        placeholder={t("knowledge.placeholder")}
        className={cn(styles.textArea, isPending && styles.textAreaPending)}
        {...rest}
      />
    </BorderBeam>
  )
}
